import { render, staticRenderFns } from "./MobileDetails.vue?vue&type=template&id=89ae0a58&scoped=true&"
import script from "./MobileDetails.vue?vue&type=script&lang=js&"
export * from "./MobileDetails.vue?vue&type=script&lang=js&"
import style0 from "./MobileDetails.vue?vue&type=style&index=0&id=89ae0a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ae0a58",
  null
  
)

export default component.exports